import { PillLabelDot } from 'common/pill-v2-label/pill-label-dot.js';
import { PillLabelV2 } from 'common/pill-v2-label/pill-label-v2.js';
import { PillDynamicWrapperV2 } from 'common/pill-v2/pill-dynamic-wrapper-v2.js';
import { MarkerDisplaySize } from 'types/location.js';
import { MarkerPillLabel } from 'types/markerTypesV2/m-v2-core.js';
import { IMarkerV2 } from 'types/markerTypesV2/m-v2-general.js';
import { predicateString } from 'utilities/isType.js';
import { FlexDivCenteredIcon } from 'utilities/svg-display/svg-layout.js';

export const MarkerLabelV2 = ({
  marker,
  selected,
  mockHover,
  markerDisplaySize,
}: {
  marker: IMarkerV2<MarkerPillLabel>;
  selected?: boolean;
  mockHover?: boolean;
  markerDisplaySize: MarkerDisplaySize;
}): JSX.Element => {
  const { position, action, label } = marker;
  const link = predicateString(action) ? action : undefined;
  return (
    <>
      <PillLabelDot />

      <PillDynamicWrapperV2
        displaySize={markerDisplaySize}
        selected={selected}
        mockHover={mockHover}
        staticPosition={position.staticPoint}
        labelPos={position.labelPos}
        markerType={marker.type}
        offset={position.offset}
        /**Only display dots as markers on pill type */
        isDot={false}
        textPos={position.textPos}
      >
        <PillLabelV2 label={label}>
          {link && (
            <FlexDivCenteredIcon classes="u-pL-xs svg--fill-inherit" icon="chevron-right" color="white" size={14} />
          )}
        </PillLabelV2>
      </PillDynamicWrapperV2>
    </>
  );
};
